import styles from "./HeaderPictureMain.module.scss";
import headerPicture from '../../../../shared/assets/photo/header/header.png';
import headerPicture_2x from '../../../../shared/assets/photo/header/header.png';
import headerMobile from '../../../../shared/assets/photo/header/header.png';
import headerMobile_2x from '../../../../shared/assets/photo/header/header_2x.png';


export const HeaderPictureMain = () => {
    return (
        <>
        <div className={styles.header}>
            <img className={styles.picture} src={headerPicture}
                    srcSet={`${headerPicture_2x} 2x`} alt="стоматология итэр" />
        </div>
        <div>
            <img className={styles.pictureMobile} src={headerMobile}
                srcSet={`${headerMobile_2x} 2x`}
                    alt="стоматология итэр" />
        </div>

        </>
    )
}